import { userFromBack } from '@root/src/entities/User/responseFormatters';
import { UserBack, UserFront } from '@root/src/entities/User/types';
import { fetchRequest, RequestMethod } from '@services/api/utils/utils';

const login = async (email: string, password: string): Promise<UserFront> =>
  fetchRequest<{ user: UserBack }, UserFront, { email: string; password: string }>({
    // point to Next API route (urlApiNext) without double /api
    endpoint: '/auth/login',
    method: RequestMethod.POST,
    responseFormatter: data => userFromBack(data.user),
    body: { email, password },
    urlApiNext: true,
  });

const logout = async (): Promise<void> =>
  fetchRequest<void, void>({
    endpoint: '/auth/logout',
    method: RequestMethod.POST,
  });

export const authApi = {
  login,
  logout,
};
